import React, { useEffect, useState } from "react";
import { AiOutlineInstagram } from "react-icons/ai";
import { Modal } from "react-responsive-modal";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaYenSign,
} from "react-icons/fa";

import { FaQuestion, FaUserCircle, FaMapPin } from "react-icons/fa";
import { Link, useHistory } from "react-router-dom";
import Logo from "../../Assets/newAsset/lpassets/clearFooter.svg";
import { FiMail, FiPhone } from "react-icons/fi";
import { Scroll } from "../Scroll function/scroll";
import "../../components/Footer/Footer.css";
import { useSelector, useDispatch, connect } from "react-redux";
import metroCross from "../../Assets/metroCross.svg";
import {
  EmptyCart,
  getCartDetails,
  newsLetterAction,
  postFrenchiseInfo,
} from "../../Redux/Actions";
import Loader from "../Loader/Loader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import PatientActions from "../Cart/PatientDetailsAction";

const Footer = (props) => {
  const newsMessage = useSelector((state) => state.newsLetter);
  const { loading, newsletterDetail } = newsMessage;
  //console.log("news payload", newsMessage);
  const history = useHistory();
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const cart = useSelector((state) => state.CartReducer);
  const { loading: loadingCity, citySelect } = citySelected;
  const [newsLetter, setNews] = useState("");
  const [openSuccModel, setSucc] = useState(false);
  const [success, setSucess] = useState(false);
  const [successMsg, setsuccessMsg] = useState(false);
  const [emailMessage, setemail] = useState(false);
  const [openModalCollectionCenter, setopenModalCollectionCenter] = useState(
    false
  );
  const [open, setOpen] = useState(false);
  const [emailError, setEmailError] = useState("");

  const { loading: loadingCart, cartDetails } = cart;
  if (loading) {
    // console.log("loading")
  } else {
    // console.log( "LOADING FALSE",cartDetails)
  }

  const onOpenModal = () => {
    const user = localStorage.getItem("user");

    if (!user) {
      history.push("/imaging");
    } else if (
      cart?.cartDetails &&
      cart?.cartDetails?.message == "cart is empty"
    ) {
      history.push("/imaging");
    } else if (
      cart?.cartDetails &&
      cart?.cartDetails[0]?.product?.length == 0
    ) {
      history.push("/imaging");
    } else {
      setOpen(true);
    }
  };

  const onCloseModal = () => setOpen(false);

  var footerImage = require("../../Assets/footer_logo.png");

  // useEffect(() => {
  //   if(newsletterDetail?.status){
  //     setemail(true)
  //   }
  // },[newsletterDetail])
  // useEffect(()=>{
  //         window.location.reload();
  // },[])

  // console.log(cart?.cartDetails)
  const openSucess = () => setSucc(true);
  const closeSuccess = () => setSucc(false);

  const dispatch = useDispatch();
  const handelNewsLetter = (e) => {
    e.preventDefault();

    const body = {
      email: newsLetter,
    };

    if (dispatch(newsLetterAction(body))) {
      //console.log("newsLetter", newsLetterDetail);
      setNews("");
    }

    if (loading) {
      return <Loader />;
    } else {
      console.log("sunmitrd", newsMessage);

      setemail(true);
      setTimeout(() => {
        setemail(false);
      }, 2000);
    }
  };

  const styles = {
    form__input: {
      marginBottom: "0rem",
    },
    main__input: {
      marginBottom: "0rem",
    },
    ioicon_margin: {
      marginRight: "6px",
    },
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props.getProfileDetails(token);
    }
  }, []);

  // console.log(props?.userProfile, "<<<<<");

  const FooterForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [email, setemail] = useState("");
    const [PhoneNumber, setPhoneNumber] = useState("");
    const [Name, setName] = useState("");
    const [newNameError, setNewNameError] = useState("");
    const [phonenumError, setPhonenumError] = useState("");

    const handleUserName = (e) => {
      setName(e.target.value);
      const characterRegex = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
      setNewNameError("");

      if (!e.target.value.match(characterRegex)) {
        setNewNameError("Enter a valid name");
      }
      if (e.target.value == "") {
        setNewNameError("");
      }
    };

    const handlePhoneNumber = (e) => {
      setPhoneNumber(e.target.value);
      let characterRegex = /^[0-9]{1}$/g;
      let mb = /^[0-9\b]+$/;
      setPhonenumError("");
      if (e.target.value.match(characterRegex)) {
        setPhonenumError("Enter a valid number");
      }
      if (e.target.value.length != 10) {
        setPhonenumError("Enter a valid number");
      }
      if (e.target.value.length != 10 && mb.test(e.target.value) == true) {
        setPhonenumError("Enter a valid number.");
      }
      if (
        e.target.value.length == 10 &&
        e.target.value.charAt(0) >= 6 &&
        mb.test(e.target.value) == true
      ) {
        setPhonenumError("");
      }
      if (e.target.value == "") {
        setPhonenumError("");
      }
    };

    const handleEmail = (e) => {
      setemail(e.target.value);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      const frenchiseBody = {
        name: Name,
        mobile: PhoneNumber,
        message: email,
        url: "https://redcliffelabs.com/franchising-opportunities",
      };
      dispatch(postFrenchiseInfo(frenchiseBody));
      // history.push("/franchising-opportunities");
      window.location.href = process.env.RAZZLE_APP_BASE_URL + "/franchising-opportunities";
    };

    // console.log(props?.userProfile,"<<<<")

    useEffect(() => {
      if (props?.userProfile?.username && props?.userProfile?.fullname) {
        setPhoneNumber(props?.userProfile?.phonenumber);
        setName(props?.userProfile?.fullname);
        setemail(props?.userProfile?.email);
      }
    }, [props?.userProfile]);

    return (
      <div className="LoginFormDivHome">
        {/* <CommonForm /> */}

        <form className="modal-form login-form " onSubmit={handleSubmit}>
          <div className="form__div">
            {/* <h4>Book Your Test</h4> */}
            <h2
              style={{
                fontSize: "3rem",
                margin: "2rem 0",
                color: "#707070",
              }}
              className="ForMargin"
            >
              Get In Touch With Us
            </h2>
            <p className="para1 ForMargin">
              Feel Free to Connect With Us For Any Queries
            </p>
            <div className="input_container">
              <div className="form__input ForMargin" style={styles.form__input}>
                <span className="userIcon">
                  <FaUserCircle />
                </span>
                <div className="inputDiv">
                  <input
                    type="text"
                    required
                    placeholder="Enter Name"
                    onChange={handleUserName}
                    value={Name}
                    style={styles.main__input}
                  />
                </div>
              </div>
              <span id="errorMessage">{newNameError}</span>
            </div>

            {/* <div className="phone_number">
                      +91 */}
            <div className="input_container">
              <div
                className="form__input numBox ForMargin"
                style={styles.form__input}
              >
                <span className="numIcon">+91</span>
                <div className="inputDiv">
                  <input
                    type="number"
                    placeholder="Enter Phone Number"
                    required
                    onChange={handlePhoneNumber}
                    value={PhoneNumber}
                    style={styles.main__input}
                  />
                </div>
              </div>
              <span id="errorMessage">{phonenumError}</span>
            </div>

            {/* </div>   */}
            <div className="citySelect ForMargin" style={styles.form__input}>
              <span className="locIcon" style={styles.ioicon_margin}>
                {" "}
                <FiMail />{" "}
              </span>

              <input
                type="email"
                placeholder="Enter Email"
                required
                onChange={handleEmail}
                value={email}
                style={styles.main__input}
              />
            </div>

            <button
              className="popupBtn"
              type="submit"
              disabled={newNameError !== "" || phonenumError !== ""}
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    );
  };

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("user"))) {
      const userProfile = JSON.parse(localStorage.getItem("user"));
      dispatch(getCartDetails(userProfile?.token));
    }
  }, []);

  const handleSubmit = () => {
    const userProfile = JSON.parse(localStorage.getItem("user"));
    userProfile && userProfile !== ""
      ? dispatch(EmptyCart(userProfile && userProfile.token))
      : null;
  };

  // Email Validation
  const validateEmail = (e) => {
    const regex = /^(?=[A-Z0-9@.%+-]{6,254}$)[A-Z0-9.%+-]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,8}[A-Z]{2,63}$/i;
    if (!regex.test(e.target.value)) {
      setEmailError("Enter a Valid Email");
    } else {
      setEmailError("");
    }
  };

  const handleCollectionCenter = () => {
    setopenModalCollectionCenter(true);
    // history.push("/collection-center-partner")
  };
  return (
    <div className="MainFooterWrapper">
      <div className="footer">
        <footer>
          {/* <ScrolltoTop /> */}
          <div className="footer-content">
            <div className="about col-xs-12 col-sm-6 col-md-3">
              <a href={process.env.RAZZLE_APP_BASE_URL}>
                {/*<LazyLoadImage src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp" alt="Logo" className="Footer__logo" delayTime='100' width="135" height="45" defer />*/}
                <LazyLoadImage
                  src={footerImage}
                  alt="Logo"
                  className="Footer__logo"
                  delayTime="100"
                  width="135"
                  height="45"
                  defer
                />
              </a>
              <p className="footer-des positionDes">
                Redcliffe Labs (unit of US based Redcliffe Lifetech Inc) is India's fastest growing technology empowered diagnostics service provider having its home sample collection service in more than 120 cities with 30+ Labs and 700+ Walk-in Wellness and Collection Centres across India. It aims to make Health tests accessible to all Indians through a perfect fusion of technology and world class state-of-the art owned labs and trusted radiology network.
              </p>
              {/* <li className={""} style={{listStyle:"none"}}>
                    <a href="//www.dmca.com/Protection/Status.aspx?ID=1b99e4c6-1519-4b52-b455-ec7671f343f9" title="DMCA.com Protection Status" className="dmca-badge"> <img src ="https://images.dmca.com/Badges/_dmca_premi_badge_1.png?ID=1b99e4c6-1519-4b52-b455-ec7671f343f9"  alt="DMCA.com Protection Status" /></a>
                    </li> */}
            </div>
            <div className="FooterTwoDiv">
              <div className="usefull-links col-xs-12 col-sm-6 col-md-3">
                <h2>Quick Links</h2>
                <ul
                  onClick={() => {
                    Scroll();
                  }}
                  className="links"
                  style={{ listStyleType: "none" }}
                >
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL}>Home</a>
                  </li>
                  <li className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/health-checkup-packages${citySelected.citySelect
                        ? `/${citySelected.citySelect
                          .toLowerCase()
                          .replaceAll(" ", "_")}`
                        : ""
                        }`}
                    >
                      Health Package
                    </a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/about-us"}>About us</a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/contact-us"}>Contact us</a>
                  </li>
                  {/* <li className={""}>
                    <Link to="/franchising-opportunities">Partner With Us</Link>
                  </li> */}
                  <li className={""}>
                    <Link to="/career">Career</Link>
                  </li>

                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/corporate-tieups"}>Corporate </a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/blog"}>My Health </a>
                  </li>
                  <li className={""}>
                    <div onClick={onOpenModal}>Redcliffe Imaging</div>

                    {/* <Link to="/Imaging">Redcliffe Imaging</Link> */}
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/patient-testimonials"}>Patient Review</a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/ourdoctors"}>Clinical Advisory</a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/franchising-opportunities"}>
                      Collection Centre Partner
                    </a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/redcliffelabs-in-association-with-wolters-kluwer"}>{"Doctors Portal > UpToDate Subscription"}</a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/media"}>Media</a>
                  </li>
                  <li className={""}>
                    <a href={process.env.RAZZLE_APP_BASE_URL + "/strategic-alliance"}>Strategic Alliance</a>
                  </li>
                </ul>
              </div>

              <div className="services col-xs-12 col-sm-6 col-md-3">
                <h2>Popular Packages</h2>
                <ul
                  onClick={() => {
                    Scroll();
                  }}
                  className="links"
                  style={{ listStyleType: "none" }}
                >
                  <li onClick={() => { }} className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/smart-full-body-checkup${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Smart Full Body Checkup
                    </a>
                  </li>

                  <li className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/kidney-function-test-kft${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Kidney Function Test
                    </a>
                  </li>

                  <li className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/liver-function-test-lft${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Liver Function Test
                    </a>
                  </li>

                  <li value="rtpcr" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/covid-rtpcr-test${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Covid - 19 RTPCR
                    </a>
                  </li>
                  <li value="advance-full-body-checkup" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/advance-full-body-checkup${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Advance Full Body Checkup
                    </a>
                  </li>
                  <li value="advance-full-body-checkup" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/healthy-heart-package${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Healthy Heart Package
                    </a>
                  </li>

                  <li value="advance-full-body-checkup" className={""}>
                    <a
                      href={process.env.RAZZLE_APP_BASE_URL + `/blood-sugar-test-package${citySelected.citySelect != ""
                        ? `-${citySelected.citySelect
                          .toLowerCase()
                          .replace(" ", "-")}`
                        : ""
                        }`}
                    >
                      Blood Sugar Test
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              id="contact-details"
              className="contact-info col-xs-12 col-sm-6 col-md-3"
            >
              <h2>Follow us on</h2>
              <div className="followUs__icon">
                <span>
                  <a
                    target="_blank"
                    href="https://www.instagram.com/redcliffelabs/"
                    className="followUs__link"
                  >
                    <AiOutlineInstagram />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.facebook.com/RedcliffeLabs/"
                    className="followUs__link"
                  >
                    <FaFacebookF />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://twitter.com/redcliffelab"
                    className="followUs__link"
                  >
                    <FaTwitter />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/redcliffe-labs/"
                    className="followUs__link"
                  >
                    <FaLinkedinIn />
                  </a>
                </span>
                <span>
                  <a
                    target="_blank"
                    href="https://www.youtube.com/c/RedcliffeLabs"
                    className="followUs__link"
                  >
                    <FaYoutube />
                  </a>
                </span>
              </div>

              <h2 className="contactUsH2">Contact </h2>
              <div className="contactUs__icon">
                <div className="contactIconsDiv">
                  <a
                    href="mailto:care@redcliffelabs.com"
                    className="followUs__link"
                  >
                    <FiMail />
                  </a>
                  <a href="mailto:care@redcliffelabs.com">
                    care@redcliffelabs.com
                  </a>
                </div>

                <div className="contactIconsDiv">
                  <a href="tel:+918988988787" className="followUs__link">
                    <FiPhone />
                  </a>

                  <a href="tel:+918988988787">898 898 8787</a>
                </div>

                <div className="contactIconsDiv">
                  <a href={process.env.RAZZLE_APP_BASE_URL + "/query"} className="followUs__link">
                    <FaQuestion />
                  </a>
                  <a href={process.env.RAZZLE_APP_BASE_URL + "/query"}>Query</a>

                </div>
                <div className="DMCADiv">
                  <a
                    href="//www.dmca.com/Protection/Status.aspx?ID=1b99e4c6-1519-4b52-b455-ec7671f343f9"
                    title="DMCA.com Protection Status"
                    className="dmca-badge"
                  >
                    {" "}
                    <img
                      src="https://www.dmca.com/PP2020/images/status/logo-w.png"
                      alt="DMCA.com Protection Status"
                      className="DMCAImg"
                    />
                  </a>
                  <p className="DMCAPara">
                    The Content on this websites is DMCA protected
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="NewsLetter">
            <div className="copyright copyNews">
              <a href={process.env.RAZZLE_APP_BASE_URL}>Redcliffe Labs </a>{" "}
              <p style={{ width: "100%" }}> © 2022. All rights reserved.</p>
            </div>
            <form onSubmit={handelNewsLetter} className="newsLetterForm">
              <h3>Subscribe To Our Newsletter</h3>
              <div className="inputNewsLetter">
                <input
                  placeholder="Enter Email ID"
                  type="email"
                  required
                  value={newsLetter}
                  onChange={(e) => { setNews(e?.target?.value), validateEmail(e) }}
                // onBlur={validateEmail}
                />
                <button disabled={!emailError == ""} type="submit">Submit</button>
              </div>
              <span className="error">{emailError}</span>
              {emailMessage ? (
                newsletterDetail ? (
                  <p>
                    {" "}
                    {newsletterDetail?.status &&
                      newsletterDetail?.status == true ? (
                      <span>Thankyou For Subscription</span>
                    ) : (
                      <span>You Have Already Subscribed</span>
                    )}
                  </p>
                ) : null
              ) : null}
              {/* {successMsg ?  newsletterDetail?.status ? ( <SuccessModel status={newsletterDetail?.status} /> ): null}  */}
            </form>
          </div>
          <hr
            style={{
              margin: "2rem 0",
              border: "0",
              borderTop: "1px solid #ddd",
            }}
          />
          <div className="bottom-content">
          <div className="copyright newBottomLogo">
              <a href={process.env.RAZZLE_APP_BASE_URL}>Redcliffe Labs </a>{" "}
              <p style={{ width: "100%" }}> © 2022. All rights reserved.</p>
            </div>
          <div className="social-icons">
              <a href={process.env.RAZZLE_APP_BASE_URL + "/terms-of-use"}>Terms of Use</a>
              <a href={process.env.RAZZLE_APP_BASE_URL + "/privacy-policy"}>Privacy Policy</a>
            </div>
           
            <div
              className="copyright"
              style={{
                display: "flex",
                // alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <p
                style={{ margin: "0", marginTop: "2rem" }}
                className="footerMargin"
              >
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
            </div>
           
          </div>
          <div className="bottom-content"></div>
        </footer>
      </div>
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div onClick={onCloseModal} className="modalCloseButton">
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <h2>Are you sure you want to empty your cart ?</h2>
          <div className="modal-inner">
            <a href={process.env.RAZZLE_APP_BASE_URL} className="modal-link" onClick={onCloseModal}>
              No
            </a>
            <Link to="/Imaging" className="modal-link" onClick={handleSubmit}>
              Yes{" "}
            </Link>
          </div>
        </div>
      </Modal>
      <Modal
        open={openModalCollectionCenter}
        onClose={() => {
          setopenModalCollectionCenter(false);
        }}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div
          onClick={() => {
            setopenModalCollectionCenter(false);
          }}
          className="modalCloseButton"
        >
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <FooterForm />
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
    leadGenrated: (body) => {
      dispatch(uploadLp(body));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Footer));
